export default __webpack_public_path__ + "static/media/logo.a4ad2f71.svg";